<template>
    <div class="container remove-padding-margin">
	    <div id="edit-nota">
	        <div class="fixed-judul fixed-top">
	            <div class="row justify-content-center align-items-center set-row">
	                <div id="idclick" class="col-md-1 col-sm-1 col-1 remove-padding" @click="back">
	                    <img src="../../assets/gambar/back-blue.svg" alt="">
	                </div>
	                <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
	                    <h6 class="font-16 font-weight-bold remove-margin">{{this.datatextnota.namapage}}</h6>
	                </div>
	                <div class="col-md-1 col-sm-1 col-1 remove-padding"></div>
	            </div>
	        </div>
	        <main class="add-padding-default">
	            <div class="flex-100">
	                <div class="flex-1 mar-top-50">
	                    <div class="font-16 color-0000 line-height-25 mar-top-16 mar-bottom-16">
	                        Teks ini tampil di bagian bawah nota transaksi. Biasanya digunakan untuk menjelaskan Syarat & Ketentuan pada laundry anda. <span class="color-206CF" @click="showExample">Lihat contoh</span>
	                    </div>
	                    
	                        <textarea class="context-nota" id="textarea" style="overflow:auto; width: 100%;height: 55vh" :disabled="!validateAccess('noteSetting.update')" v-model="datatextnota.textpage" placeholder="Teks ini akan ditampilkan dibagian bawah nota transaksi. Silakan isi teks informasi seperti Syarat Ketentuan atau yang lainnya...">
	<!--                            {{datatextnota.textpage}}-->
	                        </textarea>
		                    <ErrorMessage class="error" label="Nota" :validation="$v.datatextnota.textpage"></ErrorMessage>
	                    
	                </div>
	                <div class="button-lanjut mar-top-20" v-if="validateAccess('noteSetting.update')">
	                    <button class="btn btn-login btn-long remove-margin" id="Btntextnota" @click="postnotatransaksi">
	                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
	                              v-if="isClicked === true"></span>
	                        <span id="textBtntextnota">Simpan</span>
	                    </button>
	                </div>
	            </div>
	        </main>
	    </div>
	    <div id="example-nota" style="display: none">
		    <div class="fixed-judul fixed-top">
			    <div class="row justify-content-center align-items-center set-row">
				    <div id="" class="col-md-1 col-sm-1 col-1 remove-padding" @click="hideExample">
					    <img src="../../assets/gambar/back-blue.svg" alt="">
				    </div>
				    <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
					    <h6 class="font-16 font-weight-bold remove-margin"></h6>
				    </div>
				    <div class="col-md-1 col-sm-1 col-1 remove-padding"></div>
			    </div>
		    </div>
		    <main class="add-padding-default">
			    <div class="flex-1 mar-top-50 d-flex justify-content-center">
				    <img src="../../assets/img/contoh-nota.png" style="height: 80vh" alt="">
			    </div>
		    </main>
	    </div>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {required} from "vuelidate/lib/validators";

    export default {
        name: "NotaText",
        props:['setidoutlet','datatextnota','setidoutletsetnota'],
	    components: { ErrorMessage },
        data(){
          return{
              idoutlet:this.setidoutlet,
              outlet:{},
              edittext:'',
              isClicked:false,
			  requestHeaders: {
				  headers: {
					  'Authorization': 'Bearer ' + localStorage.getItem('token'),
				  }
			  }
          }
        },
	    validations: {
		    datatextnota: {
			    textpage: {
			    	required,
			    }
		    }
	    },
        mounted() {
            $('#textarea').focus()
            this.idoutlet = this.$route.params.idoutlet

        },
        methods:{
            back(){
                this.$emit('shownota')
                this.datatextnota.textpage=''
            },
            async postnotatransaksi(){
            	if (this.$v.datatextnota.textpage.$invalid) {
		            this.$v.datatextnota.textpage.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                this.isClicked=true
                $('#textBtntextnota').hide()
              try {
                  const posttransaksitext = new FormData
                  posttransaksitext.append(this.datatextnota.variableupdate, this.removeSpecialChar(this.datatextnota.textpage));
                  const response = await this.$axios.post(this.$baseurl + '/' + this.datatextnota.posturl + this.setidoutletsetnota, posttransaksitext,this.requestHeaders)
                  if(response.data.status===true){
                      this.isClicked=false
                      $('#textBtntextnota').show()
	                  this.$toast.success(response.data.msg)
                      this.back()
                  }else {
                  	  this.$toast.error(response.data.msg)
                      this.isClicked=false
                      $('#textBtntextnota').show()
                  }

              }  catch (e) {
	              this.$catch_error_response(e)
	              this.isClicked=false
	              $('#textBtntextnota').show()
	              $('#loadingPage').hide();
              }
            },
            async postdeposit(){
              try {
                  const postdeposittext = new FormData;
                  postdeposittext.append('nota_beli_deposit', this.datatextnota.textpage)
                  const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_nota_pembelian_deposit?idoutlet=' + this.setidoutletsetnota, postdeposittext,this.requestHeaders);
                  if(response.data.status===true){
                      this.datatextnota.textpage='';
                      this.isClicked=false
                      $('#textBtntextnota').show()
	                  this.$toast.success(response.data.msg)
                      this.back()
                  }else {
                  	  this.$toast.error(response.data.msg)
                      this.isClicked=false
                      $('#textBtntextnota').show()
                  }

              }  catch (e) {
              	  this.$catch_error_response(e)
	              this.isClicked=false
	              $('#textBtntextnota').show()
	              $('#loadingPage').hide();
	              $('#loadingPage').removeClass('overlayLoading');
              }
            },
            async postepayment(){
              try {
                  const postpayment = new FormData
                  postpayment.append('nota_beli_emoney',this.textpage)
                  const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_nota_epayment?idoutlet=' + this.setidoutlet, postpayment,this.requestHeaders);
                  if(response.data.status===true){
                      this.isClicked=false
                      $('#textBtntextnota').show()
	                  this.$toast.success(response.data.msg)
                      this.back()
                  }else {
                  	  this.$toast.error(response.data.msg)
                      this.isClicked=false
                      $('#textBtntextnota').show()
                  }
              }  catch (e) {
              	  this.$catch_error_response(e)
	              this.isClicked=false
	              $('#textBtntextnota').show()
	              $('#loadingPage').hide();
	              $('#loadingPage').removeClass('overlayLoading');
              }
            },
            async postnotajemput(){
                try {
                    const postnotajemput = new FormData
                    postnotajemput.append('nota_surat_jemput', this.textpage)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_nota_penjemputan_konsumen?idoutlet=' + this.setidoutlet,postnotajemput,this.requestHeaders);
                    if(response.data.status===true){
                        this.isClicked=false
                        $('#textBtntextnota').show()
	                    this.$toast.success(response.data.msg)
                        this.back()
                    }else {
                    	this.$toast.error(response.data.msg)
                        this.isClicked=false
                        $('#textBtntextnota').show()
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked=false
	                $('#textBtntextnota').show()
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async postmember(){
                try {
                    const postmember = new FormData
                    postmember.append('nota_daftar_member', this.textpage)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_nota_pendaftaran_member?idoutlet=' + this.setidoutlet,postmember,this.requestHeaders);
                    if(response.data.status===true){
                        this.isClicked=false
                        $('#textBtntextnota').show()
	                    this.$toast.success(response.data.msg)
                        this.back()
                    }else {
                    	this.$toast.error(response.data.msg)
                        this.isClicked=false
                        $('#textBtntextnota').show()
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked=false
	                $('#textBtntextnota').show()
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async postsuratpengantar(){
              try {
                  const postsuratpengantar = new FormData
                  postsuratpengantar.append('nota_surat_antar', this.textpage)
                  const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_nota_pengantaran_konsumen?idoutlet=' + this.setidoutlet, this.requestHeaders);
                  if(response.data.status===true){
                      this.isClicked=false
                      $('#textBtntextnota').show()
	                  this.$toast.success(response.data.msg)
                      this.back()
                  }else {
                  	  this.$toast.error(response.data.msg)
                      this.isClicked=false
                      $('#textBtntextnota').show()
                  }
              }  catch (e) {
              	  this.$catch_error_response(e)
	              this.isClicked=false
	              $('#textBtntextnota').show()
	              $('#loadingPage').hide();
	              $('#loadingPage').removeClass('overlayLoading');
              }
            },

            async postsuratantarwk(){
              try {
                  const suratantarwk = new FormData
                  suratantarwk.append('nota_surat_antar_workshop', this.textpage)
                  const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_nota_pengantaran_ws?idoutlet=' + this.setidoutlet,suratantarwk,this.requestHeaders);
                  if(response.data.status===true){
                      this.isClicked=false
                      $('#textBtntextnota').show()
	                  this.$toast.success(response.data.msg)
                      this.back()
                  }else {
                  	  this.$toast.error(response.data.msg)
                      this.isClicked=false
                      $('#textBtntextnota').show()
                  }
              }  catch (e) {
              	  this.$catch_error_response(e)
	              this.isClicked=false
	              $('#textBtntextnota').show()
	              $('#loadingPage').hide();
	              $('#loadingPage').removeClass('overlayLoading');
              }
            },

            async suratambilwk(){
                try {
                    const suratjemputwk = new FormData
                    suratjemputwk.append('nota_surat_jemput_workshop',this.textpage)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_nota_penjemputan_ws?idoutlet=' + this.setidoutlet,suratjemputwk,this.requestHeaders);
                    if(response.data.status===true){
                        this.isClicked=false
                        $('#textBtntextnota').show()
	                    this.$toast.success(response.data.msg)
                        this.back()
                    }else {
                    	this.$toast.error(response.data.msg)
                        this.isClicked=false
                        $('#textBtntextnota').show()
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked=false
	                $('#textBtntextnota').show()
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
	        showExample() {
		        $("#edit-nota").fadeOut(100);
		        setTimeout(() => {
			        $("#example-nota").fadeIn(100)
		        }, 100)
	        },
	        hideExample() {
            	$("#example-nota").fadeOut(100);
            	setTimeout(() => {
            		$("#edit-nota").fadeIn(100)
	            }, 100)
	        },
        },
    }
</script>

<style scoped>
    .context-nota{
        border: 1px solid #C8D0DD;
        box-sizing: border-box;
        border-radius: 5px;
    }

    input:focus, textarea:focus, select:focus{
        outline: none;
    }

</style>